import { contentPrinciples } from '@/mocks/feed';
import SectionHeading from '@/components/base/SectionHeading';

const positioning = [
  {
    icon: 'ri-focus-3-line',
    title: '我们做什么',
    desc: '把深夜正在发酵的话题按出现时间整理成条目，标注栏目、时段、热度和当前阶段，并给出可读的时间线。',
  },
  {
    icon: 'ri-forbid-2-line',
    title: '我们不做什么',
    desc: '不发布未经核实的指向性描述，不替任何一方下结论，也不鼓励在凌晨情绪最高的时候做转发决定。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '怎么核实',
    desc: '优先采用可公开验证的材料；缺少交叉验证的条目会标注"待核"，并在白天重新核对后补充更新。',
  },
];

const stages = [
  { label: '第一阶段', title: '从值夜开始', desc: '最开始只是几个人在凌晨互相转告消息，顺手把时间点记在文档里。' },
  { label: '第二阶段', title: '把时段分开', desc: '发现午夜、凌晨、后半夜的传播方式差别很大，于是把整夜拆成五档分别整理。' },
  { label: '第三阶段', title: '加上核实标记', desc: '一次误传之后，我们给所有条目加上了阶段与待核标记，宁可慢一点。' },
  { label: '第四阶段', title: '形成固定节奏', desc: '白天复核、夜间整理、早上汇总成一封邮件，成为现在稳定的更新节奏。' },
];

export default function AboutValues() {
  return (
    <>
      <section className="mt-16 border-t border-background-200/70 pt-14">
        <SectionHeading
          eyebrow="Positioning"
          title="网站定位：一个只负责整理的值夜台"
          desc="我们不站在任何一方，也不试图给出最终答案。把信息按时间摆整齐，交给你自己判断。"
        />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {positioning.map((item) => (
            <article key={item.title} className="rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/12 text-primary-300">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="mt-16 border-t border-background-200/70 pt-14">
        <SectionHeading
          eyebrow="Principles"
          title="内容原则：几条不太讨巧但必须守的规矩"
          desc="深夜的信息最容易被放大，所以我们把边界写在最显眼的地方。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {contentPrinciples.map((item, index) => (
            <article
              key={item.title}
              className="flex gap-4 rounded-lg border border-background-200/70 bg-background-100/50 p-5"
            >
              <span className="font-display text-2xl leading-none tracking-wide text-primary-400">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span>
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </span>
            </article>
          ))}
        </div>
      </section>

      <section className="mt-16 border-t border-background-200/70 pt-14">
        <SectionHeading
          eyebrow="How We Grow"
          title="发展理念：先慢一点，再稳一点"
          desc="这套做法不是一次成型的，而是被几次误传一点点磨出来的。"
        />
        <ol className="relative space-y-6 border-l border-background-200 pl-6 md:pl-8">
          {stages.map((stage) => (
            <li key={stage.label} className="relative">
              <span className="absolute -left-[30px] top-2 h-3 w-3 rounded-full border-2 border-background-50 bg-accent-500 md:-left-[38px]" />
              <span className="font-label text-xs tracking-widest text-accent-400">{stage.label}</span>
              <h3 className="mt-1 font-heading text-base font-bold text-foreground-950">{stage.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{stage.desc}</p>
            </li>
          ))}
        </ol>
      </section>
    </>
  );
}